export enum SeasonStatusEnum {
  Active = "ONGOING",
  Finished = "CONCLUDED",
  Canceled = "CANCELED",
  InPreparation = "IN_PREPARATION",
}
